import {Routes} from '@angular/router';

import {authGuard} from '../../guards/auth-guard/auth-guard';
import {rootAdminGuard} from '../../guards/root-admin-guard/root-admin-guard';

export const optionsRoutes: Routes = [
  {
    path: '',
    redirectTo: 'widgets',
    pathMatch: 'full',
  },
  {
    path: 'widgets',
    loadComponent: () =>
      import('./widget-management/options-widget-management.page').then(m => m.OptionsWidgetManagementPage),
    canActivate: [authGuard],
    data: {
      nav: {
        exact: true,
        label: 'nav.widget_management',
        order: 10,
      },
    },
  },
  {
    path: 'widgets/create',
    loadComponent: () =>
      import('./widget-create/options-widget-create.page').then(m => m.OptionsWidgetCreatePage),
    canActivate: [authGuard],
  },
  {
    path: 'widgets/edit/:id',
    loadComponent: () =>
      import('./widget-edit/options-widget-edit.page').then(m => m.OptionsWidgetEditPage),
    canActivate: [authGuard],
  },
  {
    path: 'price-types',
    loadComponent: () =>
      import('./price-type-management/options-price-type-management.page').then(m => m.OptionsPriceTypeManagementPage),
    canActivate: [authGuard, rootAdminGuard],
    data: {
      nav: {
        exact: true,
        label: 'nav.price_types',
        order: 20,
      },
    },
  },
  {
    path: 'price-types/create',
    loadComponent: () =>
      import('./price-type-create/options-price-type-create.page').then(m => m.OptionsPriceTypeCreatePage),
    canActivate: [authGuard, rootAdminGuard],
  },
  {
    path: 'price-types/edit/:id',
    loadComponent: () =>
      import('./price-type-edit/options-price-type-edit.page').then(m => m.OptionsPriceTypeEditPage),
    canActivate: [authGuard, rootAdminGuard],
  },
  {
    path: 'units',
    loadComponent: () => import('./unit-management/options-unit-management.page').then(m => m.OptionsUnitManagementPage),
    canActivate: [authGuard, rootAdminGuard],
    data: {nav: {exact: true, label: 'nav.units', order: 30}},
  },
  {
    path: 'units/create',
    loadComponent: () => import('./unit-form/options-unit-form.page').then(m => m.OptionsUnitFormPage),
    canActivate: [authGuard, rootAdminGuard],
  },
  {
    path: 'units/edit/:id',
    loadComponent: () => import('./unit-form/options-unit-form.page').then(m => m.OptionsUnitFormPage),
    canActivate: [authGuard, rootAdminGuard],
  },
];
